import React from "react";
import { ToastContainer } from "react-toastify";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <div className="w-full select-none">
      <ToastContainer autoClose={3000} />

      <Routes>
        <Route index path="/" element={<Navigate to="/hrm" />} />
        <Route path="/hrm/*" element={<Home />} />
        <Route path="/hrm/login" element={<Login />} />
        <Route path="/hrm/signup" element={<Signup />} />
      </Routes>
    </div>
  );
}

export default App;
